import CreateDoorkeyModal from './CreateDoorkeyModal';
import DoorkeyListPage from './DoorkeyListPage';
import EditDoorkeyModal from './EditDoorkeyModal';
import InviteCodeModal from './InviteCodeModal';

export const components = {
  CreateDoorkeyModal,
  DoorkeyListPage,
  EditDoorkeyModal,
  InviteCodeModal,
};
